import { Button } from '@mui/material';
import { IconFilter, IconMapPin } from '@tabler/icons-react';
import { useCensusFiltersContext } from './Filters/hooks/useCensusFiltersContext';

const buttonStyle = {
    height: '40px',
    borderRadius: '8px',
    borderColor: '#E9EAEB',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    padding: '0 16px',
    color: '#252B37'
};

const buttonSx = {
    '&:hover': {
        backgroundColor: '#fff',
        borderColor: '#E9EAEB',
        boxShadow: 'none'
    }
};

export const Buttons = ({ onClickFilters, onClickCityFilter }) => {
    const { filters, isCityLocked } = useCensusFiltersContext();

    return (
        <div className="d-flex" style={{ gap: '8px' }}>
            <Button
                onClick={onClickFilters}
                variant="outlined"
                startIcon={<IconFilter size={20} />}
                style={buttonStyle}
                sx={buttonSx}
            >
                Filtros
            </Button>
            {/* Usuário vinculado a um município não troca de cidade. */}
            {!isCityLocked && (
                <Button
                    onClick={onClickCityFilter}
                    variant="outlined"
                    startIcon={<IconMapPin size={20} />}
                    style={buttonStyle}
                    sx={buttonSx}
                >
                    {filters.cidade?.label}
                </Button>
            )}
        </div>
    );
};
